// Client API frontend pour l'intégration Odoo (facturation).

const BASE = "https://support.gs-group.fr/api";
const tok = () => localStorage.getItem("nexo_token");
const h = () => ({ Authorization: "Bearer " + tok() });

/** @returns {Promise<{enabled:boolean, baseUrl:string, database:string, username:string, hasApiKey:boolean, source:string, updatedAt:string|null}>} */
async function getConfig() {
  return fetch(`${BASE}/odoo/config`, { headers: h() }).then(r => r.json());
}

/** @param {object} cfg {enabled, baseUrl, database, username, apiKey?} */
async function saveConfig(cfg) {
  const r = await fetch(`${BASE}/odoo/config`, {
    method: "POST",
    headers: { ...h(), "Content-Type": "application/json" },
    body: JSON.stringify(cfg),
  });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || `Erreur ${r.status}`);
  return d;
}

/** @param {object} cfg mêmes champs que saveConfig, non persistés */
async function testConfig(cfg) {
  const r = await fetch(`${BASE}/odoo/config/test`, {
    method: "POST",
    headers: { ...h(), "Content-Type": "application/json" },
    body: JSON.stringify(cfg),
  });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || `Erreur ${r.status}`);
  return d;
}

/** Synchronise tous les véhicules du CRM vers Odoo Fleet (admin). */
async function syncFleet() {
  const r = await fetch(`${BASE}/odoo/sync-fleet`, { method: "POST", headers: h() });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || `Erreur ${r.status}`);
  return d;
}

export const odooApi = { getConfig, saveConfig, testConfig, syncFleet };
